import React from 'react';
import { apiHolder, apis } from 'api';
export const SAFE_BROWSING_SIZE_LIMIT = 200 * 1024 * 1024;
const EXT_CATEGORY_MAP = {
    '7z': 'zip',
    bmp: 'image',
    csv: 'document',
    doc: 'doc',
    docx: 'doc',
    eml: 'eml',
    exe: 'exe',
    gif: 'image',
    htm: 'html',
    html: 'html',
    ico: 'image',
    jpeg: 'image',
    jpg: 'image',
    ods: 'document',
    odp: 'document',
    odt: 'document',
    pdf: 'pdf',
    png: 'image',
    ppt: 'ppt',
    pptx: 'ppt',
    rar: 'zip',
    rtf: 'document',
    svg: 'image',
    txt: 'txt',
    webp: 'image',
    xls: 'excel',
    xlsx: 'excel',
    zip: 'zip',
};
export const SAFE_BROWSING_EXT_WHITELIST = EXT_CATEGORY_MAP;
export const getCategory = (filename) => {
    if (!filename || typeof filename !== 'string')
        return 'unknown';
    const dotIdx = filename.lastIndexOf('.');
    if (dotIdx === -1 || dotIdx === filename.length - 1)
        return 'unknown';
    const ext = filename.substring(dotIdx + 1).toLowerCase();
    return EXT_CATEGORY_MAP[ext] || 'unknown';
};
export const isSafeBrowsingSupported = (info) => {
    if (!info)
        return false;
    const cat = getCategory(info.fileName);
    if (cat === 'unknown')
        return false;
    const size = typeof info.fileSize === 'number' ? info.fileSize : 0;
    if (size <= 0)
        return false;
    return size <= SAFE_BROWSING_SIZE_LIMIT;
};
const getCurrentUid = () => {
    var _a;
    try {
        const systemApi = apiHolder.api.getSystemApi();
        return ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
    }
    catch (_b) {
        return '';
    }
};
const getCurrentSid = () => {
    var _a;
    try {
        const systemApi = apiHolder.api.getSystemApi();
        return ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.sessionId) || '';
    }
    catch (_b) {
        return '';
    }
};
const htmlApi = apiHolder.api.requireLogicalApi(apis.htmlApi);
const getCleanSubject = (raw) => {
    if (!raw)
        return '';
    try {
        return htmlApi.decodeHtml(raw.replace(/<\/?b>/g, ''));
    }
    catch (_a) {
        return '';
    }
};
const getOrigin = () => {
    if (typeof window !== 'undefined' && window.location) {
        return `${window.location.protocol}//${window.location.host}`;
    }
    return '';
};
export const buildLinkUrl = (targetUrl, subject) => {
    const base = `${getOrigin()}/projects/safe-browsing/index.html`;
    const sid = getCurrentSid();
    const params = [`uid=${encodeURIComponent(getCurrentUid())}`];
    if (sid)
        params.push(`sid=${encodeURIComponent(sid)}`);
    const cleanSubject = getCleanSubject(subject);
    if (cleanSubject)
        params.push(`subject=${encodeURIComponent(cleanSubject)}`);
    params.push(`targetUrl=${encodeURIComponent(targetUrl || '')}`);
    return `${base}?${params.join('&')}`;
};
export const buildAttachUrl = (opts) => {
    const base = `${getOrigin()}/projects/safe-browsing/attachment.html`;
    const sid = getCurrentSid();
    const params = [`uid=${encodeURIComponent(getCurrentUid())}`];
    if (sid)
        params.push(`sid=${encodeURIComponent(sid)}`);
    const cleanSubject = getCleanSubject(opts.subject);
    if (cleanSubject)
        params.push(`subject=${encodeURIComponent(cleanSubject)}`);
    if (opts.type === 'cloud') {
        params.push('attachType=cloud');
        params.push(`fileKey=${encodeURIComponent(opts.fileKey || '')}`);
        if (opts.mid)
            params.push(`mid=${encodeURIComponent(opts.mid)}`);
    }
    else {
        params.push('attachType=attachment');
        params.push(`mid=${encodeURIComponent(opts.mid || '')}`);
        params.push(`partId=${encodeURIComponent(opts.partId || '')}`);
    }
    if (opts.fileUrl)
        params.push(`fileUrl=${encodeURIComponent(opts.fileUrl)}`);
    if (opts.fileName)
        params.push(`fileName=${encodeURIComponent(opts.fileName)}`);
    return `${base}?${params.join('&')}`;
};
export const SHIELD_SVG_HTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">' +
    '<path d="M16 11.374C16 15.1233 13.1562 16.998 9.77625 18.0853C9.59926 18.1407 9.407 18.138 9.23188 18.0778C5.84375 16.998 3 15.1233 3 11.374V6.12483C3 5.92596 3.0856 5.73522 3.23798 5.59459C3.39035 5.45396 3.59701 5.37496 3.8125 5.37496C5.4375 5.37496 7.46875 4.47511 8.8825 3.3353C9.05463 3.19957 9.2736 3.125 9.5 3.125C9.7264 3.125 9.94537 3.19957 10.1175 3.3353C11.5394 4.48261 13.5625 5.37496 15.1875 5.37496C15.403 5.37496 15.6097 5.45396 15.762 5.59459C15.9144 5.73522 16 5.92596 16 6.12483V11.374Z" stroke="#3F465C" stroke-linecap="round" stroke-linejoin="round" />' +
    '<line x1="6.5" y1="10.625" x2="12.5" y2="10.625" stroke="#3F465C" stroke-linecap="round" />' +
    '<line x1="9.5" y1="7.625" x2="9.5" y2="13.625" stroke="#3F465C" stroke-linecap="round" />' +
    '</svg>';
export const ShieldSvgIcon = ({ size = 20, stroke = '#3F465C', className }) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 20 20", fill: "none", className: className },
    React.createElement("path", { d: "M16 11.374C16 15.1233 13.1562 16.998 9.77625 18.0853C9.59926 18.1407 9.407 18.138 9.23188 18.0778C5.84375 16.998 3 15.1233 3 11.374V6.12483C3 5.92596 3.0856 5.73522 3.23798 5.59459C3.39035 5.45396 3.59701 5.37496 3.8125 5.37496C5.4375 5.37496 7.46875 4.47511 8.8825 3.3353C9.05463 3.19957 9.2736 3.125 9.5 3.125C9.7264 3.125 9.94537 3.19957 10.1175 3.3353C11.5394 4.48261 13.5625 5.37496 15.1875 5.37496C15.403 5.37496 15.6097 5.45396 15.762 5.59459C15.9144 5.73522 16 5.92596 16 6.12483V11.374Z", stroke: stroke, strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("line", { x1: "6.5", y1: "10.625", x2: "12.5", y2: "10.625", stroke: stroke, strokeLinecap: "round" }),
    React.createElement("line", { x1: "9.5", y1: "7.625", x2: "9.5", y2: "13.625", stroke: stroke, strokeLinecap: "round" })));
